import { render, staticRenderFns } from "./NotificationGroupTable.vue?vue&type=template&id=40ce63d6&scoped=true"
import script from "./NotificationGroupTable.vue?vue&type=script&lang=js"
export * from "./NotificationGroupTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationGroupTable.vue?vue&type=style&index=0&id=40ce63d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce63d6",
  null
  
)

export default component.exports